import { ThemeButton } from '@shared/ui/buttons';
import { useCreateTeamDialog } from '@utils/dialogs-hooks';
import { useTranslation } from 'react-i18next';

export default function CreateTeamBtn() {
  const { openCreateTeamDialog } = useCreateTeamDialog();
  const { t } = useTranslation();
  return (
    <ThemeButton onClick={() => openCreateTeamDialog(null)} startIcon="add">
      {t('create_team')}
    </ThemeButton>
  );
}
